import React from 'react';
import { observer } from 'mobx-react';
import { MenuItem } from 'core/components';
import $auth from 'app/stores/$auth';
import SudoTaggedText from 'app/components/SudoTaggedText';
import BoardPanelModel from 'app/stores/boards/BoardPanelModel';

interface Props {
  panel: BoardPanelModel;
}

/**
 * Sudo-only menu item for the board panel hamburger that opens the UDE debug dialog.
 * Owns its own open state and renders the dialog alongside the item (mirroring RemoveMenuItem);
 * shouldDismissPopover={false} keeps the item mounted so the dialog persists.
 */
function UdeDebugMenuItem({ panel }: Props) {
  const { queryModel } = panel;

  if (!$auth.isSudoer || !queryModel) {
    return null;
  }

  return (
    <>
      <MenuItem
        icon="diagnosis"
        text={<SudoTaggedText>Debug</SudoTaggedText>}
        shouldDismissPopover={false}
        onClick={() => queryModel.handleShowDebugDialog()}
      />
    </>
  );
}

export default observer(UdeDebugMenuItem);
